import { Injectable } from '@angular/core'
import { MatDialogConfig } from '@angular/material/dialog'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { ReviewsInsightsGuestSentiment } from '@tokeet-frontend/reviews'
import { ReviewInsightsGuestSentimentsDialogComponent } from './review-insights-guest-sentiments-dialog.component'

@Injectable()
export class ReviewInsightsGuestSentimentsDialogService {
  constructor(private dialog: DialogService) {}

  open(items: ReviewsInsightsGuestSentiment[]) {
    let defaultConfig: MatDialogConfig = {
      width: '80%',
      data: { items },
    }

    return this.dialog.openFixedDialog(ReviewInsightsGuestSentimentsDialogComponent, defaultConfig)
  }
}
